import {
  BuyersActivityTrackEvents,
  BUYERS_ACTIVITY_PLATFORM_TYPE_CODE,
  BUYERS_ACTIVITY_DATA_ROOM_TYPE_CODE,
  BuyersActivityTrack,
  BUYERS_ACTIVITY_TRACK_TYPE,
  BUYERS_ACTIVITY_TRACK_EVENTS,
  BUYERS_ACTIVITY_TRACK_EVENTS_COPY,
} from 'models/Lead';

export const PLATFORM_CODE_TO_EVENT = Object.entries(
  BUYERS_ACTIVITY_PLATFORM_TYPE_CODE,
).reduce((acc, [event, code]) => ({ ...acc, [code]: event }), {}) as Record<
  number,
  BuyersActivityTrackEvents
>;

export const DATA_ROOM_CODE_TO_EVENT = Object.entries(
  BUYERS_ACTIVITY_DATA_ROOM_TYPE_CODE,
).reduce((acc, [event, code]) => ({ ...acc, [code]: event }), {}) as Record<
  number,
  BuyersActivityTrackEvents
>;

export const getEventKey = ({
  type,
  platformTypeCode,
  dataRoomTypeCode,
}: Partial<BuyersActivityTrack>) => {
  switch (type) {
    case BUYERS_ACTIVITY_TRACK_TYPE.PLATFORM:
      return PLATFORM_CODE_TO_EVENT[platformTypeCode];
    case BUYERS_ACTIVITY_TRACK_TYPE.DATA_ROOM:
      return DATA_ROOM_CODE_TO_EVENT[dataRoomTypeCode];
    default:
      return BUYERS_ACTIVITY_TRACK_EVENTS.NOTIFIED;
  }
};

export const getActivityCopyKey = (activity: Partial<BuyersActivityTrack>) => {
  const eventKey = getEventKey(activity);

  if (
    eventKey === BUYERS_ACTIVITY_TRACK_EVENTS.RELEASE_ORDER_MESSAGE_SENT &&
    !activity.dataRoomNodeId
  )
    return 'releaseOrderMessageSentAtEnd';

  return BUYERS_ACTIVITY_TRACK_EVENTS_COPY[eventKey];
};
